import Entity from "./entity";

class Area extends Entity {
  constructor(data) {
    super(data);

    this.label = this.label  || null;
    this.shortDescription = this.shortDescription  || null;
    this.validFrom = !!this.validFrom ? this.convertDate(this.validFrom).startOf('d') : null;
    this.validTo = !!this.validTo ? this.convertDate(this.validTo).endOf('d') : null;

    this.value = this.id;
  }

  get valid() {
    return !this.validTo || this.validTo.isSameOrAfter();
  }

}

export default Area;



// WEBPACK FOOTER //
// ./client/domain/area.js